import StartingPageContent from '../components/StartingPage/StartingPageContent';

const HomePage = () => <StartingPageContent />;

export default HomePage;
